import { animate, state, style, transition, trigger } from '@angular/animations';

export const grow = trigger(
    'grow',
    [
        state('void', style({transform: 'scale(0)'})),
        transition(':enter', [animate(150)]),
        transition(':leave', [animate(150)]),
    ]
);

export const fadeIn = trigger(
    'fadeIn',
    [
        state('void', style({opacity: '0'})),
        transition(':enter', [animate(100)]),
    ]
);

export const fadeInOut = trigger(
    'fadeInOut',
    [
        state('void', style({opacity: '0'})),
        transition(':leave', [animate(200)]),
        transition(':enter', [animate(500)]),
    ]
);

export const pingFadeInOut = trigger(
    'pingFadeInOut',
    [
        state('void', style({ opacity: '0' })),
        transition(':enter', [animate(200)]),
        transition(':leave', [animate(200)]),
    ],
);

export const popupShootUp = trigger(
    'popupShootUp',
    [
        state('void', style({ transform: 'translateY(100%)' })),
        transition(':enter, :leave', [animate('250ms')]),
    ]
);

export const backdroopFadeIn = trigger(
    'backdroopFadeIn',
    [
        state('void', style({opacity: '0'})),
        transition(':enter, :leave', [animate('250ms')]),
    ]
);

export const tabsFadeAnimation = trigger(
    'tabsFadeAnimation',
    [
        state('faded-out', style({ opacity: 0})),
        state('faded-in', style({ opacity: 1})),
        transition('faded-out => faded-in', [ animate(150) ]),
        transition('faded-in => faded-out', [ animate(0) ]),
    ]
);
